// removed by extract-text-webpack-plugin
module.exports = {"closed":"SideBarActivities__closed___2Hgua","taskbar":"SideBarActivities__taskbar___2wSvF","header":"SideBarActivities__header___qFHYW","toggleCompleted":"SideBarActivities__toggleCompleted___2VAaR","taskSection":"SideBarActivities__taskSection___3xiRA","tabs":"SideBarActivities__tabs___1bS1C","tab":"SideBarActivities__tab___32MyZ","tabscontainer":"SideBarActivities__tabscontainer___1_mGD","toggleLabel":"SideBarActivities__toggleLabel___1CpVy","newTask":"SideBarActivities__newTask___ITzrL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SideBarActivities/SideBarActivities.scss
// module id = 1193
// module chunks = 1